module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "news-top-left.884ea7f3.webp" + "?" + Date.now();